import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { EnderecoModel } from 'app/model/endereco/endereco.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class EnderecoService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  getEndereco(): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-endereco', this.httpOptions);
  }

  getPageEndereco(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-endereco?page=${page}&size=${size}`, this.httpOptions);
  }

  postEndereco(endereco: EnderecoModel): Observable<EnderecoModel>{
    return this.httpClient.post<EnderecoModel>(this.apiURL + '/new/adicionar-endereco', endereco, this.httpOptions);
  }

  putEndereco(endereco: EnderecoModel): Observable<EnderecoModel> {
    return this.httpClient.put<EnderecoModel>(this.apiURL + '/edit/editar-endereco', endereco, this.httpOptions);
  }

  deleteEndereco(id: any) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + '/delete/apagar-endereco/' + id, { headers, responseType: 'text'});
  }

  getEnderecosCliente(id: any): Observable<any>{
    return this.httpClient.get<any>(this.apiURL + '/view/listar-enderecos-cliente/' + id, this.httpOptions)
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/endereco/endereco.service.ts